import React from 'react';

import classnames from 'classnames/bind';

import EnhancedContent from './components/EnhancedContent';

import styles from './AppSettings.module.scss';

const cx: CX = classnames.bind(styles);

function AppSettingsPage() {
    return (
        <div className={cx('page')}>
            <div className="container max-constraint center">
                <h1>
                    Application & Document Settings
                </h1>
                <EnhancedContent />
            </div>
        </div>
    );
}

export default AppSettingsPage;
